<template>
  <div>
    <SubHeader :page="currentRole.title"></SubHeader>
    <div class="open-position-content">
      <div class="open-position-content-desc block-el">

        <div v-html="currentRole.description"></div>

        <div class="open-position-content-sections" v-for="section in currentRole.sections">

          <div class="open-position-content-section-heading">
            {{ section.heading }}
          </div>

          <div class="open-position-content-section-content" v-if="section.textContent" v-html="section.textContent"></div>

          <span class="open-position-content-section-content-bullet"
                v-for="bullet in section.bullets">
            <span class="bullet-heading" v-show="bullet.type == 'heading'">{{ bullet.content }}</span>
            <span class="bullet-list-item" v-show="bullet.type == 'bullet'">
              <i class="fa fa-circle-thin"></i>
              <label>{{ bullet.content }}</label>
            </span>
          </span>
        </div>

        <a href="#contact-footer" class="apply-now-button" v-on:click="resetScroll">Apply Now</a>
        <div class="apply-now-text">
          Apply now by filling out our contact form, or send an email to hola at mikmak dot tv
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SubHeader from './common/SubHeader'

export default {
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    SubHeader
  },
  methods: {
    resetScroll() {
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    }
  },
  computed: {
    currentRole() {
      let role
      this.careersContent.positions.map((position) => {
        if (position.slug == this.roleSlug) role = position
      })

      return role
    },
    careersContent() {
      return this.$store.state.careersContent
    },
    roleSlug() {
      let slug = ''
      if (this.$route.params.slug) slug = this.$route.params.slug

      return slug
    }
  },
  watch: {}
}
</script>

<style scoped>

  .block-el {
    display: block;
    width: 75%;
    margin: 24px auto;
    color: #333;
  }

  @media only screen and (max-width: 800px) {
    .block-el {
      width: 95%;
      font-size: 20px;
    }
  }

  .open-position-content {
    padding-bottom: 32px;
  }

  .open-position-content-desc {
    font-family: 'Work Sans', sans-serif;
    font-size: 18px;
  }

  .open-position-content-sections {
    display: block;
  }

  .open-position-content-section-heading {
    font-size: 20px;
    font-weight: bold;
    margin-top: 32px;
    text-transform: uppercase;
    margin-bottom: 12px;
    color: #00BFBD;
  }

  .open-position-content-section-content {

  }

  .open-position-content-section-content-bullet {

  }

  .bullet-heading {
    font-weight: bold;
    color: #333;
    display: block;
    margin-top: 24px;
    text-decoration: underline;
  }

  .bullet-list-item {
    display: block;
    white-space: pre-line;
    margin: 8px;
  }

  .bullet-list-item i {
    display: inline-block;
    vertical-align: top;
    font-size: 12px;
    margin-top: 6px;
  }

  .bullet-list-item label {
    display: inline-block;
    width: 90%;
    vertical-align: top;
  }

  .apply-now-text {
    display: block;
    font-family: 'Work Sans', sans-serif;
    font-size: 12px;
  }

  .apply-now-button {
    display: block;
    font-family: 'Work Sans', sans-serif;
    background: #00BFBD;
    width: 150px;
    text-align: center;
    color: honeydew;
    text-decoration: none;
    padding: 2px;
    border-radius: 4px;
    margin: 8px 0;
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// OpenPositions.vue?7907e851